import React, { useState } from 'react';
import { makeStyles, tokens, Text } from '@fluentui/react-components';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import PageSidebar from './sidebar';
import PageContent from './contentbar';
//import PageBreadcrumb from './breadcrumb';
import Headerbar from './headerbar';

const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflow: 'hidden',
  },
  bodyContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflow: 'hidden',
  },
  footer: {
    textAlign: 'center',
    padding: tokens.spacingVerticalL,
    backgroundColor: tokens.colorNeutralBackground1,
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    width: '100%',
  },
  overlay: {
    '@media (max-width: 768px)': {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
      display: 'block',
    },
    display: 'none',
  },
});

const PageLayout: React.FC = () => {
  const styles = useStyles();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  return (
    <div className={styles.root}>
      <Headerbar onMenuClick={toggleMobileSidebar} />
      <div className={styles.bodyContainer}>
        {isMobileSidebarOpen && (
          <div className={styles.overlay} onClick={closeMobileSidebar} />
        )}
        <PageSidebar
          isOpen={isMobileSidebarOpen}
          onClose={closeMobileSidebar}
        />
        <div className={styles.mainContent}>
          {/*<PageBreadcrumb />*/}
          <AuthenticatedTemplate>
            <PageContent />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Text
              style={{
                fontSize: '1.5rem',
                marginLeft: '48px',
                marginTop: '48px',
                display: 'block',
              }}
            >
              Please log in to continue
            </Text>
          </UnauthenticatedTemplate>
        </div>
      </div>
      <footer className={styles.footer}>
        <Text>©{new Date().getFullYear()}</Text>
      </footer>
    </div>
  );
};

export default PageLayout;
